// @flow

const CONTENT_WIDTH = 700;
const WIDTH_WITH_MARGINS = CONTENT_WIDTH + 8 * 4;

const referralsContentStyles = {
  tableContainer: (theme) => ({
    flexGrow: 1,
    width: '100%',
    padding: theme.spacing(3), // Desktop padding: 24px all around
    [theme.breakpoints.down('sm')]: {
      minWidth: 0,
      padding: 0 // Mobile: NO padding (ContentContainer handles spacing)
      // paddingTop is now handled by ContentContainer wrapper
    }
  }),

  refPageCtr: (theme) => ({
    marginTop: theme.spacing(4)
  }),

  withoutLabel: (theme) => ({
    marginTop: theme.spacing(3)
  }),

  textField: (theme) => ({
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%'
    }
  }),

  outlinedLinkUrl: (theme) => ({
    borderRadius: 0,
    minWidth: WIDTH_WITH_MARGINS,
    margin: `${theme.spacing(1)} 0 0 0`,
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%'
    }
  }),

  kpiCtr: (theme) => ({
    display: 'flex',
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2)
    }
  }),

  kpiDiv: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    width: CONTENT_WIDTH / 3,
    borderRadius: 0,
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5)
    }
  }),

  kpiCaption: (theme) => ({
    color: 'hsl(0, 0%, 0%)',
    textTransform: 'uppercase',
    paddingTop: theme.spacing(2)
  }),

  kpiNb: (theme) => ({
    lineHeight: '1',
    paddingBottom: theme.spacing(2)
  }),

  linkLegend: (theme) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(4)
  }),

  referralLanguageTextForm: (theme) => ({
    display: 'flex',
    alignItems: 'flex-start',
    '& button': {
      position: 'relative',
      right: 50,
      top: theme.spacing(2)
    }
  }),

  referralLanguageTextField: (theme) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(5),
    width: WIDTH_WITH_MARGINS,
    '& div': {
      borderRadius: 0
    },
    [theme.breakpoints.down('sm')]: {
      width: CONTENT_WIDTH + 8 * 2
    }
  }),

  blockquoteCtr: (theme) => ({
    maxWidth: WIDTH_WITH_MARGINS,
    '& blockquote': {
      borderLeft: '4px solid #ccc',
      paddingLeft: theme.spacing(2),
      marginLeft: 0,
      fontStyle: 'italic',
      color: theme.palette.text.secondary
    }
  })
};

export default referralsContentStyles;
